import { render, staticRenderFns } from "./AddressPTSearch.vue?vue&type=template&id=927f4634"
import script from "./AddressPTSearch.vue?vue&type=script&lang=js"
export * from "./AddressPTSearch.vue?vue&type=script&lang=js"
import style0 from "./AddressPTSearch.vue?vue&type=style&index=0&id=927f4634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports